export default __webpack_public_path__ + "static/Heimordnung-82b974ed48a04a0e8ed877cae871f366.pdf";